import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useSettingsStore } from "~/stores/SettingsStore.js"
import { useLocalePath } from '#imports';


export default defineNuxtRouteMiddleware((to, from) => {
    if (to.name?.startsWith('login') || !useSettingsStore().translatable('acknowledgement')) {
        return;
    }

    const localePath = useLocalePath();
    let url = localePath({name: 'login'}) + '/';
    if (!to.name?.startsWith('index')) {
        url += '?redirect=' + encodeURIComponent(to.fullPath);
    }
    return navigateTo(url);
})
